import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	intro: {
		marginBottom: 16,
	},
	review: {
		border: "1px solid #F3D9A4",
		backgroundColor: "#FFFAF0",
		borderRadius: 8,
		boxShadow: "none",
		marginBottom: 16,
		"&:before": {
			display: "none",
		},
	},
	reviewTitle: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		fontSize: 15,
		fontWeight: 600,
	},
	notBillable: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 12,
		padding: "12px 16px",
		marginBottom: 16,
		border: "1px solid #F3D9A4",
		backgroundColor: "#FFFAF0",
		borderRadius: 8,
	},
	notBillableText: {
		flex: 1,
		minWidth: 200,
	},
	// Greyed only: the buttons are disabled, and the review list and tooltips still open.
	greyed: {
		opacity: 0.6,
	},
	boardCell: {
		display: "inline-flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 4,
	},
	codeLine: {
		display: "inline-flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 8,
	},
	muted: {
		color: theme.palette.text.secondary,
	},
	tipIcon: {
		display: "inline-flex",
		verticalAlign: "middle",
		marginLeft: 6,
		cursor: "help",
	},
} satisfies Record<string, CSSObject>);
